import DeleteSeedAudienceModal from './DeleteSeedAudienceModal.Container';

export default DeleteSeedAudienceModal;
